import reducer from './cookie-consent.reducer'
import { NAME } from './cookie-consent.constants'

export * from './cookie-consent.action'

export { NAME, reducer }
